var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('st-data-table',{attrs:{"items":_vm.taxes,"fields":_vm.fields,"actions":_vm.actions,"modelPresenter":_vm.presenter,"hover":""},on:{"edit":_vm.onEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }